import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=1bd39788&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=ts&"
export * from "./Carousel.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=1bd39788&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd39788",
  null
  
)

export default component.exports